// extracted by mini-css-extract-plugin
export default {"leave":"_3z_RB","leaveActive":"DoL4h"};